(() => {
  const $ = (selector, root = document) => root.querySelector(selector);
  const $$ = (selector, root = document) => [...root.querySelectorAll(selector)];

  const menuButton = $('[data-mobile-menu]');
  const nav = $('[data-site-nav]');
  if (menuButton && nav) menuButton.addEventListener('click', () => nav.classList.toggle('is-open'));

  const categoriesButton = $('[data-categories-toggle]');
  const categoriesDrawer = $('[data-category-drawer]');
  if (categoriesButton && categoriesDrawer) categoriesButton.addEventListener('click', () => {
    categoriesDrawer.hidden = !categoriesDrawer.hidden;
    categoriesButton.setAttribute('aria-expanded', String(!categoriesDrawer.hidden));
  });

  const searchButton = $('[data-search-toggle]');
  const searchForm = $('[data-search-form]');
  if (searchButton && searchForm) searchButton.addEventListener('click', () => {
    searchForm.classList.toggle('is-visible');
    if (searchForm.classList.contains('is-visible')) $('input', searchForm)?.focus();
  });

  $$('[data-qty-minus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.closest('.dh-quantity')?.querySelector('input');
    if (input) input.value = Math.max(1, Number(input.value || 1) - 1);
  }));
  $$('[data-qty-plus]').forEach((button) => button.addEventListener('click', () => {
    const input = button.closest('.dh-quantity')?.querySelector('input');
    if (input) input.value = Number(input.value || 1) + 1;
  }));

  $$('[data-media-src]').forEach((button) => button.addEventListener('click', () => {
    const main = $('[data-main-media] img');
    if (main) main.src = button.dataset.mediaSrc;
    $$('[data-media-src]').forEach((item) => item.classList.remove('is-active'));
    button.classList.add('is-active');
  }));

  $$('[data-variant-select]').forEach((select) => select.addEventListener('change', () => {
    const option = select.options[select.selectedIndex];
    const scope = select.closest('.dh-product-info');
    const priceArea = scope?.querySelector('[data-price-area]');
    const addButton = scope?.querySelector('.dh-add-button');
    const buyButton = scope?.querySelector('[data-buy-now]');
    if (priceArea) priceArea.innerHTML = `<strong>${option.dataset.price || ''}</strong>${option.dataset.compare ? `<s>${option.dataset.compare}</s><span>Sale</span>` : ''}`;
    const available = option.dataset.available === 'true';
    if (addButton) { addButton.disabled = !available; addButton.textContent = available ? 'Add to cart' : 'Sold out'; }
    if (buyButton) buyButton.disabled = !available;
    const url = new URL(window.location.href);
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url.toString());
  }));

  $$('[data-tab]').forEach((button) => button.addEventListener('click', () => {
    const scope = button.closest('.dh-product-details');
    if (!scope) return;
    $$('[data-tab]', scope).forEach((item) => item.classList.toggle('is-active', item === button));
    $$('[data-panel]', scope).forEach((panel) => panel.classList.toggle('is-active', panel.dataset.panel === button.dataset.tab));
  }));

  $$('[data-sort-by]').forEach((select) => select.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', select.value);
    window.location.assign(url.toString());
  }));

  const toast = $('[data-cart-toast]');
  const showToast = () => {
    if (!toast) return;
    toast.classList.add('is-visible');
    window.setTimeout(() => toast.classList.remove('is-visible'), 2400);
  };

  $$('[data-ajax-cart-form]').forEach((form) => form.addEventListener('submit', async (event) => {
    if (!window.fetch || form.dataset.standardSubmit === 'true') return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    if (submit) submit.disabled = true;
    try {
      const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`).then((result) => result.json());
      $$('[data-cart-count]').forEach((bubble) => { bubble.textContent = cart.item_count; });
      showToast();
    } catch (error) {
      form.dataset.standardSubmit = 'true';
      form.submit();
    } finally {
      if (submit) submit.disabled = false;
    }
  }));

  $$('[data-buy-now]').forEach((button) => button.addEventListener('click', () => {
    const form = button.closest('form');
    if (!form) return;
    form.dataset.standardSubmit = 'true';
    let redirect = form.querySelector('input[name="return_to"]');
    if (!redirect) { redirect = document.createElement('input'); redirect.type = 'hidden'; redirect.name = 'return_to'; form.appendChild(redirect); }
    redirect.value = '/checkout';
    form.submit();
  }));
})();
